import { render, staticRenderFns } from "./knowledge.vue?vue&type=template&id=3ede97a4&scoped=true"
import script from "./knowledge.vue?vue&type=script&lang=js"
export * from "./knowledge.vue?vue&type=script&lang=js"
import style0 from "./knowledge.vue?vue&type=style&index=0&id=3ede97a4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ede97a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ede97a4')) {
      api.createRecord('3ede97a4', component.options)
    } else {
      api.reload('3ede97a4', component.options)
    }
    module.hot.accept("./knowledge.vue?vue&type=template&id=3ede97a4&scoped=true", function () {
      api.rerender('3ede97a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/research/knowledge.vue"
export default component.exports